




































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Factura } from '@/pantallas/Facturacion/fetchFacturaciones';

@Component({})
export default class FacturaResumen extends Vue {
  @Prop() facturaSeleccionada: Factura;
}
